import { LEFT_PANELS } from 'constants/feature/panel-constants';
import {
  toggleExportPanel,
  toggleSubPanelWithinExport,
} from 'store/actions/panel-controller-actions';

export const showDownloadTabInsideExport = () => (dispatch, getState) => {
  const {
    ui: {
      statementPage: {
        panels: { left },
      },
    },
  } = getState();
  if (left !== LEFT_PANELS.EXPORT && left !== LEFT_PANELS.DOWNLOAD) {
    dispatch(toggleExportPanel(LEFT_PANELS.DOWNLOAD));
  } else if (left === LEFT_PANELS.EXPORT) {
    dispatch(toggleSubPanelWithinExport());
  }
};
